import React from 'react';
import { Switch } from 'react-router-dom';

import AuthorizedRoute from '../../_helpers/authorized.route';
import ContainerLayout from '../../_layouts/Container/';

import ListQuestions from './List/';
import CreateQuestion from './Create';
import EditQuestion from './Edit/';

export default () => {
  return (
    <Switch>
      <AuthorizedRoute path="/questions/:id/edit" layout={ContainerLayout} component={EditQuestion} />
      <AuthorizedRoute path="/questions/create" layout={ContainerLayout} component={CreateQuestion} />
      <AuthorizedRoute path="/" layout={ContainerLayout} component={ListQuestions} />
    </Switch>
  );
}